import { createTypes, createAction } from "lib/action";

const LOAD_CLOSE_WORK = createTypes("closework", "load");


const loadCloseWork = {
  request: (params, token) =>
    createAction(LOAD_CLOSE_WORK.REQUEST, { params, token }),
  success: (data) => createAction(LOAD_CLOSE_WORK.SUCCESS, { data }),
  failure: (err) => createAction(LOAD_CLOSE_WORK.FAILURE, { err }),
};

export {
  loadCloseWork,
  LOAD_CLOSE_WORK,
};
